<template>
  <img src="/prisma.png" alt="PRISMA" />
</template>
